import React from 'react';
export function PrivacyPolicy() {
  return <div className="text-gray-700 space-y-4" data-id="element-408">
      <h3 className="text-lg font-bold text-amber-900" data-id="element-409">
        Política de Privacidad
      </h3>
      <p data-id="element-410">Última actualización: 1 de septiembre de 2024</p>
      <p data-id="element-411">
        Stella Pereira ("nosotros", "nuestro" o "Método Milhojas Perfecta") se
        compromete a proteger su privacidad. Esta Política de Privacidad explica
        cómo recopilamos, usamos y protegemos su información personal cuando
        utiliza nuestro sitio web y servicios.
      </p>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-412">
        1. Información que recopilamos
      </h4>
      <p data-id="element-413">Podemos recopilar la siguiente información:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-414">
        <li data-id="element-415">
          Información personal como nombre, dirección de correo electrónico y
          detalles de contacto.
        </li>
        <li data-id="element-416">
          Información de pago para procesar compras (a través de procesadores de
          pago seguros).
        </li>
        <li data-id="element-417">Información sobre cómo utiliza nuestro sitio web y servicios.</li>
        <li data-id="element-418">
          Información demográfica y preferencias para mejorar nuestros productos
          y servicios.
        </li>
      </ul>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-419">
        2. Cómo utilizamos su información
      </h4>
      <p data-id="element-420">Utilizamos la información recopilada para:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-421">
        <li data-id="element-422">Proporcionar y mejorar nuestros servicios y productos.</li>
        <li data-id="element-423">Procesar transacciones y enviar confirmaciones de compra.</li>
        <li data-id="element-424">Enviar materiales educativos y acceso a cursos comprados.</li>
        <li data-id="element-425">
          Comunicarnos con usted sobre actualizaciones, ofertas y novedades
          relacionadas con nuestros servicios.
        </li>
        <li data-id="element-426">
          Personalizar su experiencia y responder a sus necesidades
          individuales.
        </li>
      </ul>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-427">
        3. Seguridad de la información
      </h4>
      <p data-id="element-428">
        Estamos comprometidos con garantizar que su información esté segura.
        Para evitar el acceso o divulgación no autorizados, hemos implementado
        procedimientos físicos, electrónicos y administrativos adecuados para
        salvaguardar la información que recopilamos en línea.
      </p>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-429">4. Cookies</h4>
      <p data-id="element-430">
        Utilizamos cookies para mejorar la experiencia del usuario. Las cookies
        son pequeños archivos que un sitio web coloca en su computadora para
        recordar información sobre su visita. Puede configurar su navegador para
        rechazar cookies, pero esto puede limitar algunas funcionalidades de
        nuestro sitio.
      </p>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-431">
        5. Compartir información
      </h4>
      <p data-id="element-432">
        No vendemos, distribuimos ni arrendamos su información personal a
        terceros a menos que tengamos su permiso o estemos obligados por ley a
        hacerlo. Podemos utilizar su información personal para enviarle
        información promocional sobre terceros que creemos que puede interesarle
        si nos indica que desea recibir estos materiales.
      </p>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-433">
        6. Acceso y control de su información
      </h4>
      <p data-id="element-434">
        Tiene derecho a acceder, corregir o eliminar su información personal. Si
        desea ejercer estos derechos o tiene preguntas sobre nuestra política de
        privacidad, contáctenos a través de los canales proporcionados al final
        de esta política.
      </p>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-435">
        7. Cambios en nuestra política de privacidad
      </h4>
      <p data-id="element-436">
        Podemos actualizar nuestra política de privacidad periódicamente.
        Cualquier cambio se publicará en esta página con una fecha de
        actualización revisada. Le recomendamos revisar esta política
        regularmente para mantenerse informado sobre cómo protegemos su
        información.
      </p>
      <h4 className="font-bold text-amber-800 mt-4" data-id="element-437">8. Contacto</h4>
      <p data-id="element-438">
        Si tiene preguntas sobre esta política de privacidad, puede contactarnos
        en:
        <br data-id="element-439" />
        Email: info@metodomilhojasperfecta.com
      </p>
    </div>;
}